module.exports = __webpack_public_path__ + "static/media/qr.624da003.png";